import { useIsAnalyticsModuleEnabled } from "src/hooks/useIsAnalyticsModuleEnabled";
import { useIsCaseManagementEnabled } from "src/hooks/useIsCaseManagementEnabled";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

type CaseAnalyticsAccess = {
  canAccess: boolean;
};

export const useCaseAnalyticsAccess = (): CaseAnalyticsAccess => {
  const { isEnabled: isAnalyticsModuleEnabled } = useIsAnalyticsModuleEnabled();
  const { isEnabled: isCaseManagementEnabled } = useIsCaseManagementEnabled();

  const canAccess =
    isFeatureFlagEnabled(FEATURE_FLAGS.caseAnalytics) &&
    isAnalyticsModuleEnabled &&
    isCaseManagementEnabled;

  return { canAccess };
};
